import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './Navbar.css';

// Get initials from name (e.g., "Muhammad Farid Zaki" -> "MZ")
const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    // Single word - return first 2 characters
    return parts[0].substring(0, 2).toUpperCase();
  }
  // Multiple words - return first letter of first and last word
  const first = parts[0][0] || '';
  const last = parts[parts.length - 1][0] || '';
  return (first + last).toUpperCase();
};

const Navbar = () => {
  const { user, token, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/dashboard" className="navbar-brand">
          Gliana QR
        </Link>
        
        {token && (
          <>
            <button className="navbar-toggle" onClick={() => setIsOpen(!isOpen)}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                {isOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
            
            <div className={`navbar-menu ${isOpen ? 'open' : ''}`}>
              <Link 
                to="/dashboard" 
                className={`navbar-link ${isActive('/dashboard') ? 'active' : ''}`}
                onClick={() => setIsOpen(false)}
              >
                Dashboard
              </Link>
              <Link 
                to="/qr-codes" 
                className={`navbar-link ${isActive('/qr-codes') ? 'active' : ''}`}
                onClick={() => setIsOpen(false)}
              >
                QR Codes
              </Link>
              <Link 
                to="/analytics" 
                className={`navbar-link ${isActive('/analytics') ? 'active' : ''}`}
                onClick={() => setIsOpen(false)}
              >
                Analytics
              </Link>
              <Link 
                to="/billing" 
                className={`navbar-link ${isActive('/billing') ? 'active' : ''}`}
                onClick={() => setIsOpen(false)}
              >
                Billing
              </Link>
              
              {user && (
                <div className="navbar-user">
                  {user.picture ? (
                    <img src={user.picture} alt={user.name || user.email} />
                  ) : (
                    <div style={{ 
                      width: 32, 
                      height: 32, 
                      borderRadius: '50%', 
                      background: 'var(--gradient-primary)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: 'white',
                      letterSpacing: '0.5px'
                    }}>
                      {getInitials(user.name || user.email)}
                    </div>
                  )}
                  <span>{user.name || user.email}</span>
                </div>
              )}
              
              <button onClick={handleLogout} className="navbar-logout">
                Logout
              </button>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
